import { useEffect, useState } from "react"

const NetworkStatus = () => {
	const [isOnline, setIsOnline] = useState<boolean>(navigator.onLine)

	const goOnline = () => setIsOnline(true)
	const goOffline = () => setIsOnline(false)

	useEffect(() => {
		window.addEventListener("online", goOnline)
		window.addEventListener("offline", goOffline)

		return () => {
			window.removeEventListener("online", goOnline)
			window.removeEventListener("offline", goOffline)
		}
	}, [])

	if (isOnline) return null

	return (
		<div className="z-50 w-full bg-red-600 py-2 text-center text-sm text-white shadow-md">
			You are offline. Changes won’t be saved until you reconnect.
		</div>
	)
}

export default NetworkStatus
